import { Divider, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useMemo } from 'react';
import { TRANSPORT_ADMIN, TRANSPORT_COORDINATOR } from '../constants';
import AdditionalDetails from './AdditionalDetails';
import EscortDetails from './EscortDetails';
import RecurrenceRules from './RecurrenceRules';
import { useScopeCheck } from '../../../../reusable-components/scopes';

AdditionalDetailsStep.propTypes = {
  form: PropTypes.shape({
    formState: PropTypes.object.isRequired,
    formDispatch: PropTypes.func.isRequired,
  }).isRequired,
  setFields: PropTypes.func.isRequired,
  setIsAdditionalDetailsSelected: PropTypes.func.isRequired,
};

export default function AdditionalDetailsStep({ form, setFields, setIsAdditionalDetailsSelected }) {
  const { formState } = form;
  const setSingleField = (field, value) => setFields({ [field]: value });
  const allowSetRecurrenceRules = useScopeCheck([TRANSPORT_ADMIN, TRANSPORT_COORDINATOR], false, true);

  const isAdditionalDetailsValid = useMemo(() => {
    const validRecurrenceSchedule =
      !formState.IsRecurring || (formState.RecurrenceType && formState.RecurrenceFrequency);
    const aideRequiredValid = typeof formState.AideRequired === 'boolean';
    const unitAideRequiredValid = typeof formState.UnitAideRequired === 'boolean';
    const cnaRequiredValid = typeof formState.CNARequired === 'boolean';
    return validRecurrenceSchedule && aideRequiredValid && unitAideRequiredValid && cnaRequiredValid;
  }, [formState]);

  useEffect(() => {
    if (isAdditionalDetailsValid) setIsAdditionalDetailsSelected(true);
    else setIsAdditionalDetailsSelected(false);
  }, [isAdditionalDetailsValid, setIsAdditionalDetailsSelected]);

  return (
    <Stack spacing={1}>
      {allowSetRecurrenceRules && (
        <>
          <RecurrenceRules formState={formState} setFields={setFields} />
          <Divider variant="middle" />
        </>
      )}
      <EscortDetails
        aideRequired={formState.AideRequired}
        unitAideRequired={formState.UnitAideRequired}
        cnaRequired={formState.CNARequired}
        setter={setSingleField}
      />
      <Divider variant="middle" />
      <AdditionalDetails details={formState} setDetail={setSingleField} />
    </Stack>
  );
}
